/* Lissée Paris — suggesties onder het zoekveld in de header, 14 september 2026 (Ruben).
   Bij het typen verschijnen de producten en collecties die het dichtst bij de letters komen,
   via de voorspellende zoek-API van Shopify (/search/suggest.json, met typo-tolerantie).
   Het zoekveld zelf staat in sections/header.liquid (form.header__search); dit script hangt er
   een lijst onder en raakt de sectie verder niet aan. Opmaak: assets/lissee-custom.css (.lissee-ps). */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN = 1;          /* vanaf de eerste letter (Ruben, 14 sep 2026) */
  var DELAY = 220;      /* ms wachten na de laatste toetsaanslag */
  var LIMIT = 6;        /* producten in de lijst */
  var cache = {};

  var money = (function () {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }); } catch (e) { return null; }
  })();
  function fmt(v) { v = Number(v) || 0; return money ? money.format(v) : '€' + v.toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_160x$1$3');
  }

  function build(form, input) {
    var box = document.createElement('div');
    box.className = 'lissee-ps';
    box.id = 'lissee-ps';
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    form.appendChild(box);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'lissee-ps');
    input.setAttribute('aria-expanded', 'false');

    var timer = null, controller = null, active = -1, lastQuery = '';

    function close() {
      box.hidden = true;
      box.innerHTML = '';
      active = -1;
      input.setAttribute('aria-expanded', 'false');
      form.classList.remove('has-suggestions');
    }

    function items() { return Array.prototype.slice.call(box.querySelectorAll('[data-ps-item]')); }

    function setActive(i) {
      var list = items();
      if (!list.length) return;
      if (i < 0) i = list.length - 1;
      if (i >= list.length) i = 0;
      list.forEach(function (el, n) { el.classList.toggle('is-active', n === i); el.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      active = i;
      list[i].scrollIntoView({ block: 'nearest' });
    }

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = (r.products || []).slice(0, LIMIT);
      var collections = (r.collections || []).slice(0, 3);
      var html = '';

      if (collections.length) {
        html += '<div class="lissee-ps__chips">';
        collections.forEach(function (c) {
          html += '<a class="lissee-ps__chip" data-ps-item role="option" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        });
        html += '</div>';
      }

      if (products.length) {
        html += '<div class="lissee-ps__list">';
        products.forEach(function (p) {
          var onSale = p.compare_at_price_max && Number(p.compare_at_price_max) > Number(p.price);
          html += '<a class="lissee-ps__item" data-ps-item role="option" href="' + esc(p.url) + '">' +
            (p.featured_image && p.featured_image.url ? '<img class="lissee-ps__img" src="' + esc(img(p.featured_image.url)) + '" alt="" loading="lazy" width="48" height="60">' : '<span class="lissee-ps__img"></span>') +
            '<span class="lissee-ps__body"><span class="lissee-ps__title">' + esc(p.title) + '</span>' +
            '<span class="lissee-ps__price">' + (onSale ? '<s>' + esc(fmt(p.compare_at_price_max)) + '</s> ' : '') + esc(fmt(p.price)) + '</span></span>' +
            '</a>';
        });
        html += '</div>';
      }

      if (!products.length && !collections.length) {
        html += '<p class="lissee-ps__empty">Aucun résultat pour « ' + esc(q) + ' »</p>';
      } else {
        html += '<a class="lissee-ps__all" data-ps-item role="option" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last">Voir tous les résultats pour « ' + esc(q) + ' »</a>';
      }

      box.innerHTML = html;
      box.hidden = false;
      active = -1;
      input.setAttribute('aria-expanded', 'true');
      form.classList.add('has-suggestions');
    }

    function search(q) {
      lastQuery = q;
      if (cache[q]) { render(q, cache[q]); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || q !== lastQuery) return;
          cache[q] = data;
          render(q, data);
        })
        .catch(function () { /* afgebroken of netwerkfout: lijst laten zoals hij is */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN) { close(); return; }
      timer = setTimeout(function () { search(q); }, DELAY);
    });

    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length >= MIN && box.hidden && cache[q]) render(q, cache[q]);
    });

    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); var el = items()[active]; if (el) window.location.href = el.href; }
      else if (e.key === 'Escape') { close(); }
    });

    form.addEventListener('reset', close);
    /* Alleen echte klikken buiten het veld sluiten de lijst. Het thema klikt zelf programmatisch op
       knoppen (page-dots van het voordelenblok bij een carousel:change); die zijn isTrusted === false
       en mogen de lijst niet sluiten — zelfde oorzaak als bij de winkelmandlade, 14 sep 2026. */
    document.addEventListener('click', function (e) { if (e.isTrusted === false) return; if (!form.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    /* Bij een verversing van de header (thema-editor) de lijst niet laten zweven. */
    document.addEventListener('shopify:section:load', close);
  }

  function init() {
    var form = document.querySelector('#shopify-section-header form.header__search');
    var input = form && form.querySelector('input[name="q"]');
    if (!form || !input || form.querySelector('.lissee-ps')) return;
    if (window.getComputedStyle(form).position === 'static') form.style.position = 'relative';
    build(form, input);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
